import { render, staticRenderFns } from "./blog-two-column.vue?vue&type=template&id=18eabcbc&"
import script from "./blog-two-column.vue?vue&type=script&lang=js&"
export * from "./blog-two-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports